module.exports = __webpack_public_path__ + "img/patent_image7.20e6c861.png";